import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Translate, I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import * as actions from "../redux/actions/marketstoreCategoriesActions";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

class CategoryItem extends React.Component {
  render() {
    return (
      <Link to="#" className="marketstore-category-link">
        {this.props.item.Name}
      </Link>
    );
  }
}
class StoreInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogin: true,
      nextLoad: 0,
      loading: true,
      error: null,
      data: [],
    };
  }

  componentDidMount() {
    if (this.props.marketstore?.Id) {
      this.fetchCategoriesMarketStore();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.marketstore?.Id !== this.props.marketstore?.Id &&
      this.props.marketstore?.Id
    ) {
      this.fetchCategoriesMarketStore();
    }
  }

  fetchCategoriesMarketStore = async () => {
    if (!this.props.marketstore?.Id) return;

    await this.props.LoadCategoriesMarketStore(this.props.token, {
      store_id: this.props.marketstore.Id,
      id: this.props.user_id,
      lang: I18n.t("locale"),
    });
  };

  componentWillUnmount() { }

  render() {
    return (
      <div className="marketstore-sidebar-card">
        <div className="marketstore-sidebar-card-header">
          <Translate value="summary" />
        </div>
        <div className="marketstore-sidebar-card-body">
          <input
            type="text"
            className="form-control marketstore-sidebar-search"
            name="searcher"
            placeholder={I18n.t("search")}
            maxLength="80"
            autoComplete="off"
          />
          <span className="marketstore-sidebar-stat">
            Total <Translate value="store_ads" />: {this.props.adList.length}
          </span>

          <h6 className="marketstore-sidebar-section-title">
            <Translate value="ad_category" />
          </h6>

          <div>
            {this.props.categories.map((item) => (
              <CategoryItem item={item} key={item.Id} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(reducer) {
  //console.log(reducer);
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,

    marketstore: reducer.marketstore.item,

    adList: reducer.marketstoreAdList.list,

    loading: reducer.marketstoreCategories.loading,
    categories: reducer.marketstoreCategories.list,
    error: reducer.marketstoreCategories.error,
  };
}
const mapDispatchToProps = (dispatch) => ({
  LoadCategoriesMarketStore: (token, params) =>
    dispatch(actions.loadList({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreInformation);
